import { Typography } from '@mui/material';

import { useTopBannerRef } from './hooks/useTopBannerRef';
import { useTopBannerStyles } from './useTopBannerStyles';

export interface TopBannerProps {
  children: string | undefined;
}

export const TopBanner = ({ children }: TopBannerProps) => {
  const { classes } = useTopBannerStyles();

  const refCallback = useTopBannerRef();

  return (
    <div className={classes.root} ref={refCallback}>
      <Typography variant="body3" className={classes.text}>
        {children}
      </Typography>
    </div>
  );
};
